import React from "react";
import EngageTodayGoal from "./EngageTodayGoal/EngageTodayGoal";
import DailyGoalStreakPage from "./DailyGoalStreak/DailyGoalStreakPage";
import ScholarLeague from "./ScholarLeague/ScholarLeague";
import "./DailyGoalStreak/DailyGoalStreakPage.css";
import "./EngageHomepage.css";

const DEFAULT_WEEK = [
  { key: "mon", label: "M", state: "done" },
  { key: "tue", label: "T", state: "done" },
  { key: "wed", label: "W", state: "today" },
  { key: "thu", label: "T", state: "upcoming" },
  { key: "fri", label: "F", state: "upcoming" },
  { key: "sat", label: "S", state: "upcoming" },
  { key: "sun", label: "S", state: "upcoming" },
];

function EngageHomepage({
  streakDays = 26,
  weekDays = DEFAULT_WEEK,
  onEditGoal,
  totalAttempt = "",
  progressPercentRaw = "",
  todayPoints = 0,
  motivationMessage = "",
  handleOpenDailyGoalModal,
}) {
  return (
    <div className="engage-homepage__grid">
      <section className="engage-homepage__left" aria-label="Engage overview">
        <EngageTodayGoal
          goalSummary={totalAttempt}
          progressPercent={Number(String(progressPercentRaw).replace("%", ""))}
          pointsEarnedToday={todayPoints ?? 0}
          motivationMessage={motivationMessage}
          onEditGoal={() => {
            if (typeof onEditGoal === "function") {
              onEditGoal();
            } else if (typeof handleOpenDailyGoalModal === "function") {
              handleOpenDailyGoalModal();
            }
          }}
        />

        <DailyGoalStreakPage
          streakDays={streakDays}
          weekDays={weekDays}
          embedded
          cardClassName="engage-homepage__streak-card"
        />
      </section>

      <aside className="engage-homepage__right" aria-label="League achievements">
        <ScholarLeague showHeader={false} compact />
      </aside>
    </div>
  );
}

export default EngageHomepage;
